// @flow

import React, { useEffect } from 'react'
import glamorous from 'glamorous'

import Events from 'lib/analytics/event-tags'
import {
  trackImpression,
  trackLinkWithData,
  tracking,
  getEventName,
} from 'lib/analytics'

import clientData from 'utils/client-data'
import { getProfilePhotoUrl } from 'utils/photo'
import { getDisplayName } from 'utils/name'

import CoverPhoto from 'screens/shared/components/cover-photo'
import ProfileCard from 'screens/shared/components/profile-card'
import Share from 'components/share'

import { INSTRUMENTATION_MAP } from 'utils/constants'

const INSTRUMENTATION = INSTRUMENTATION_MAP.profile

const { locality: { locale, country } = {} } = clientData

const Container = glamorous.div({
  marginTop: '1.75rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

const CoverContainer = glamorous.div({
  zIndex: 0,
  marginBottom: '-6.375rem',
})

const ProfileCardContainer = glamorous.div({
  zIndex: 1,
})

const ShareContainer = glamorous.div({
  maxWidth: '21.5rem',
  marginTop: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative', // for copied tooltip
})

type Props = {
  history: {
    push: () => any,
  },
  settings: SettingsState,
}

function MyProfile(props: Props) {
  const {
    settings: {
      state: {
        slugDetails = {},
        slugDetails: {
          paypalmeSlugName = '',
          userInfo: {
            profilePhotoUrl = '',
            displayName = '',
            displayAddress = '',
          } = {},
          personalizationSettings: {
            coverPhotoUrl = '',
            coverPhotoVerticalPan = '50',
            welcomeNote = '',
          } = {},
        } = {},
      } = {},
    } = {},
  } = props

  useEffect(() => {
    trackImpression(
      INSTRUMENTATION.OLD.PAGE_GROUP,
      INSTRUMENTATION.OLD.PAGE_NAME,
    )
    tracking(Events.public_identity_my_profile_screen_shown({}))
  }, [])

  const onShare = (platform: string) => {
    trackLinkWithData(
      'share',
      INSTRUMENTATION.OLD.PAGE_GROUP,
      INSTRUMENTATION.OLD.PAGE_NAME,
      { event_name: getEventName(INSTRUMENTATION, 'share'), platform },
      'link',
    )
    tracking(Events.public_identity_my_profile_share_pressed({}))
  }

  return (
    <Container>
      <CoverContainer>
        <CoverPhoto
          photoUrl={coverPhotoUrl}
          photoVerticalPan={coverPhotoVerticalPan}
        />
      </CoverContainer>
      <ProfileCardContainer>
        <ProfileCard
          photoUrl={getProfilePhotoUrl(profilePhotoUrl)}
          displayName={getDisplayName(displayName)}
          handle={`@${paypalmeSlugName}`}
          displayLocation={displayAddress}
          blurb={welcomeNote}
        />
      </ProfileCardContainer>
      <ShareContainer>
        <Share
          locale={locale}
          country={country}
          slugInfo={{ slugDetails }}
          onShare={onShare}
        />
      </ShareContainer>
    </Container>
  )
}

export default MyProfile
